import { useSelector } from "react-redux";
import AppView from './AppView';
import BrowserView from "./BrowserView";
import CalendarView from './CalendarView';
import { VoiceCallView } from './call';
import EmailView from "./EmailView";
import MessagingView from "./MessagingView";
import AgentView from "./AgentView.js";
// Note: Live channel removed from config - it now only triggers via WebSocket as an overlay

export const componentMap = {
  sms: MessagingView,
  email: EmailView,
  browser: BrowserView,
  agent: AgentView,
  call: VoiceCallView,
  calendar: CalendarView,
  app: AppView,
};

export default function ChannelContent({ isEnvironmentOffline = false }) {
  const { currentChannel, channelConfig } = useSelector((state) => state.channel);
  const channelInfo = channelConfig[currentChannel] || {};
  
  // Handle special channels
  if (currentChannel === 'home') {
    // HomeView is handled in DeviceFrame, this shouldn't render for home
    return null;
  }
  
  // All channels use their specified type from config
  const channelType = channelInfo.type;

  const ComponentToRender = componentMap[channelType];

  if (ComponentToRender) {
    return <ComponentToRender isEnvironmentOffline={isEnvironmentOffline} />;
  }

  // Fallback for an unknown channel type
  return <div className="p-4 text-center text-gray-400">Unknown Channel Type: {channelType}</div>;
}
